import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {ExamFormModel} from '../../../api/model/exam-form.model';
import {AbstractRepositoryV2} from '../../../../core/service/v2/abstractRepositoryV2';

@Injectable()
export class ExamFormRepository extends AbstractRepositoryV2<ExamFormModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ExamForm', serviceElementsFactory, injector);
    }
}
